import axios from 'axios'

export function RequestCollection() {
  return axios.request({
    method: 'get',
    baseURL: `${process.env.REACT_APP_API_URL}/nfts/all`,
    proxy: {
      protocol: 'http',
      host: 'localhost',
      port: 4001,
    },
    headers: { 'Access-Control-Allow-Origin': '*' },
  })
}
